import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import LoginForm from '../../components/LoginForm';
import {
  AUTH_STORE,
  NOTIFICATION_STORE,
  PRODUCT_STORE,
  COMPANY_STORE,
  ORDER_TYPES_STORE,
  CUSTOMER_STORE,
  FILTER_STORE } from '../../constants/constants';
import { AuthStore } from '../../stores/AuthStore';

@inject(
  AUTH_STORE,
  NOTIFICATION_STORE,
  PRODUCT_STORE,
  COMPANY_STORE,
  ORDER_TYPES_STORE,
  CUSTOMER_STORE,
  FILTER_STORE
)
@observer
class Login extends React.Component {

  async componentDidMount() {
    const loginData = await this.props[AUTH_STORE].testIsLoggedIn();
    if (loginData.status && loginData.status === 'success') {
      this.fetchData();
    }
  }

  async login(email: string, password: string) {
    if (!this.props[COMPANY_STORE].selectedCompany) {
      this.props[NOTIFICATION_STORE].addNotification({
        type: 'error',
        message: 'Valitse yhtiö!',
        seen: false
      });
      return;
    }

    const loginData = await this.props[AUTH_STORE].login(email, password);

    if (loginData.status === 'fail') {
      this.props[NOTIFICATION_STORE].addNotification({
        type: 'error',
        message: loginData.message,
        seen: false
      });
    } else {
      this.fetchData();
    }
  }

  fetchData() {
    this.props[AUTH_STORE].getUserRole();
    this.props[PRODUCT_STORE].fetchProducts();
    this.props[ORDER_TYPES_STORE].getOrderTypes();
    this.props[CUSTOMER_STORE].fetchCustomers();
    this.props[FILTER_STORE].fetchFilters();
  }

  selectCompany(company: string) {
    this.setState({ company });
    this.props[COMPANY_STORE].setCompany(company);
  }

  render() {
    const isLoggedIn = this.props[AUTH_STORE].isLoggedIn;
    const selectedCompany = this.props[COMPANY_STORE].selectedCompany;
    return (
      <div className="section section--login-form">
        {
          isLoggedIn ? (
            <Redirect to="/products"/>
          ) : (
            <LoginForm
              login={(email, password) => this.login(email, password)}
              selectCompany={(company => this.selectCompany(company))}
              selectedCompany={selectedCompany}
            />
          )
        }
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/login/Login.tsx